module.exports = __webpack_public_path__ + "static/media/clear-night.a54880ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather/clear-night.png
// module id = 6651
// module chunks = 0